import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasePermissionComponent } from './base-permission.component';
import { CanDirective } from './permission.directive';
import { CanPipe } from './can.pipe';
import { CanFieldPipe } from './can-field.pipe';
import { CanTabPipe } from './can-tab.pipe';
import { HasPermissionDirective } from '../../shared/directives/has-permission.directive';
import { PermissionBlockedComponent } from './permission-blocked.component';
import { PermissionButtonDirective } from './permission-button.directive';

@NgModule({
  imports: [CommonModule, HasPermissionDirective, PermissionBlockedComponent],
  declarations: [
    BasePermissionComponent,
    CanDirective,
    CanPipe,
    CanFieldPipe,
    CanTabPipe,
    PermissionButtonDirective,
  ],
  exports: [
    BasePermissionComponent,
    CanDirective,
    CanPipe,
    CanFieldPipe,
    CanTabPipe,
    HasPermissionDirective,
    PermissionBlockedComponent,
    PermissionButtonDirective,
  ],
})
export class PermissionsModule {}
